module.exports = vendors_ru_3a3c8b450d55de2c1c13;